import { disputeContextView, type DisputeRaisedContext } from './dispute-context.ts';
import { Facts, TableScroll } from './ui.tsx';

/**
 * What was on record when a dispute was raised, for both sides: the operator
 * investigating it and the affiliate who raised it read the same snapshot.
 */
export function DisputeContextPanel({ context }: { context: DisputeRaisedContext }) {
  const v = disputeContextView(context);
  return (
    <section className="stack">
      {/* No default heading margin: with the list's own, it left a blank band
          between the heading and the first card (owner, 2026-10-06). */}
      <h3 style={{ margin: 0 }}>{v.title}</h3>
      <Facts items={v.facts} />
      {v.figures.length > 0 ? <Facts items={v.figures} /> : null}
      {v.tables.map((table) => (
        <TableScroll key={table.caption}>
          <table>
            <caption>{table.caption}</caption>
            <thead>
              <tr>
                {table.columns.map((c, i) => (
                  <th key={c} scope="col" className={i > 0 ? 'num' : undefined}>{c}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {table.rows.map((row, i) => (
                <tr key={i}>
                  {row.map((cell, j) => (
                    <td key={j} className={j > 0 ? 'num' : undefined}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </TableScroll>
      ))}
      <p className="faint">{v.note}</p>
    </section>
  );
}
